import { string } from 'prop-types'

function PhoneCallHelp() {
    return (
        <p>
            En cas de besoin n'hésite pas à nous joindre au <br />
            <strong>{'0 806 23 00 24'}</strong>
        </p>
    )
}

PhoneCallHelp.propTypes = {
    tunnelType: string,
}

export default PhoneCallHelp
